(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.featured-collection-carousel').forEach(function(section) {
      var track = section.querySelector('.collection-carousel__track');
      var prevBtn = section.querySelector('[data-carousel-prev]');
      var nextBtn = section.querySelector('[data-carousel-next]');
      var dots = section.querySelectorAll('[data-carousel-dot]');

      if (!track || track.dataset.carouselBound === 'true') return;
      track.dataset.carouselBound = 'true';

      function getItemWidth() {
        var item = track.querySelector('.collection-carousel__item');
        if (!item) return 300;
        var style = getComputedStyle(track);
        var gap = parseInt(style.gap) || 24;
        return item.offsetWidth + gap;
      }

      function scrollToIndex(index) {
        var itemWidth = getItemWidth();
        track.scrollTo({
          left: index * itemWidth * 4,
          behavior: 'smooth'
        });
      }

      function updateDots() {
        if (!dots.length) return;
        var itemWidth = getItemWidth();
        var currentIndex = Math.round(track.scrollLeft / (itemWidth * 4));
        dots.forEach(function(dot, i) {
          dot.classList.toggle('active', i === currentIndex);
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          var itemWidth = getItemWidth();
          track.scrollBy({ left: -itemWidth * 4, behavior: 'smooth' });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          var itemWidth = getItemWidth();
          track.scrollBy({ left: itemWidth * 4, behavior: 'smooth' });
        });
      }

      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          var index = parseInt(dot.dataset.index);
          scrollToIndex(index);
        });
      });

      track.addEventListener('scroll', function() {
        requestAnimationFrame(updateDots);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["market-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initMarketCarousel = (root) => {
      if (root.dataset.carouselReady === 'true') return;

      const viewport = root.querySelector('[data-carousel-viewport]');
      const cards = Array.from(root.querySelectorAll('[data-carousel-card]'));
      const section = root.closest('.market-gallery');
      const previousButton = section?.querySelector('[data-carousel-prev]');
      const nextButton = section?.querySelector('[data-carousel-next]');
      const toggleButton = section?.querySelector('[data-carousel-toggle]');
      const toggleLabel = section?.querySelector('[data-carousel-toggle-label]');
      const counter = section?.querySelector('[data-carousel-counter]');

      if (!viewport || cards.length < 2 || !previousButton || !nextButton || !toggleButton || !toggleLabel || !counter) return;

      root.dataset.carouselReady = 'true';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const requestedAutoplay = root.dataset.autoplay === 'true';
      let currentIndex = 0;
      let timer = null;
      let scrollFrame = null;
      let userPaused = !requestedAutoplay || reducedMotion.matches;
      let pointerInside = false;
      let focusInside = false;

      const cardLeft = (card) => card.offsetLeft - cards[0].offsetLeft;

      const setControlState = () => {
        const paused = userPaused || pointerInside || focusInside || document.hidden;
        toggleLabel.textContent = userPaused ? 'Play' : 'Pause';
        toggleButton.setAttribute('aria-label', userPaused ? 'Play moving market photographs' : 'Pause moving market photographs');
        toggleButton.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        if (paused && timer) {
          window.clearInterval(timer);
          timer = null;
        }
      };

      const updateCounter = () => {
        const current = String(currentIndex + 1).padStart(2, '0');
        const total = String(cards.length).padStart(2, '0');
        counter.textContent = `${current} / ${total}`;
      };

      const goTo = (index, behavior = 'smooth') => {
        currentIndex = (index + cards.length) % cards.length;
        viewport.scrollTo({ left: cardLeft(cards[currentIndex]), behavior });
        updateCounter();
      };

      const start = () => {
        setControlState();
        if (userPaused || pointerInside || focusInside || document.hidden || timer) return;
        timer = window.setInterval(() => goTo(currentIndex + 1), 4200);
      };

      previousButton.addEventListener('click', () => {
        goTo(currentIndex - 1);
        start();
      });

      nextButton.addEventListener('click', () => {
        goTo(currentIndex + 1);
        start();
      });

      toggleButton.addEventListener('click', () => {
        userPaused = !userPaused;
        if (userPaused && timer) {
          window.clearInterval(timer);
          timer = null;
        }
        setControlState();
        start();
      });

      viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(currentIndex - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(currentIndex + 1);
        }
      });

      viewport.addEventListener('scroll', () => {
        if (scrollFrame) return;
        scrollFrame = window.requestAnimationFrame(() => {
          const left = viewport.scrollLeft;
          currentIndex = cards.reduce((nearest, card, index) => {
            return Math.abs(cardLeft(card) - left) < Math.abs(cardLeft(cards[nearest]) - left) ? index : nearest;
          }, 0);
          updateCounter();
          scrollFrame = null;
        });
      }, { passive: true });

      root.addEventListener('mouseenter', () => {
        pointerInside = true;
        setControlState();
      });

      root.addEventListener('mouseleave', () => {
        pointerInside = false;
        start();
      });

      section.addEventListener('focusin', () => {
        focusInside = true;
        setControlState();
      });

      section.addEventListener('focusout', (event) => {
        if (!section.contains(event.relatedTarget)) {
          focusInside = false;
          start();
        }
      });

      document.addEventListener('visibilitychange', start);
      reducedMotion.addEventListener('change', (event) => {
        if (event.matches) userPaused = true;
        setControlState();
        start();
      });

      updateCounter();
      setControlState();
      start();
    };

    const initAllMarketCarousels = (scope = document) => {
      scope.querySelectorAll('[data-market-carousel]').forEach(initMarketCarousel);
    };

    initAllMarketCarousels();
    document.addEventListener('shopify:section:load', (event) => initAllMarketCarousels(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-product-form]').forEach(function(form) {
    var select = form.querySelector('[data-variant-select]');
    var button = form.querySelector('[data-add-to-cart]');
    if (!select || !button) return;

    select.addEventListener('change', function() {
      var option = select.options[select.selectedIndex];
      var available = option && option.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? 'Add to bag' : 'Sold out';
    });
  });

  } catch(e) { console.error(e); }
})();
})();
